import React, {useRef, useState} from 'react';
import {FormattedMessage} from 'react-intl';
import classNames from 'classnames';
import messages from '../../res/translations/messages';

// Taken from https://stackoverflow.com/a/42844911/2564990
export default function ClipboardCopyInput({className, ...rest}) {
    const inputRef = useRef(null);
    const [copied, setCopied] = useState(false);
    const isCopySupported = document.queryCommandSupported('copy');

    function copyToClipboard(e) {
        inputRef.current.select();
        document.execCommand('copy');
        e.target.focus();
        setCopied(true);
    }

    return (
        <div className={classNames('input-group', className)}>
            <input type="text" className="form-control" ref={inputRef} {...rest} />
            {isCopySupported && (
                <div className="input-group-append">
                    { /* eslint-disable-next-line react/jsx-no-bind */ }
                    <button className="btn btn-outline-secondary" type="button" onClick={copyToClipboard}>
                        <FormattedMessage {...messages.buttons[copied ? 'copied' : 'copy']} />
                    </button>
                </div>
            )}
        </div>
    );
}
